var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaypal = function SvgPaypal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#009CDE",
    fillRule: "evenodd",
    d: "M37.097 5.318C35.061 2.995 31.384 2 26.678 2H13.021c-.961 0-1.78.7-1.93 1.652L5.404 39.76a1.173 1.173 0 0 0 1.158 1.357h8.432l-.582 3.695A1.027 1.027 0 0 0 15.425 46h7.107a1.71 1.71 0 0 0 1.688-1.445l.07-.362 1.338-8.5.087-.47a1.71 1.71 0 0 1 1.688-1.445h1.063c6.885 0 12.276-2.8 13.852-10.9.657-3.385.318-6.21-1.423-8.197-.527-.6-1.181-1.097-1.945-1.503.535-3.422-.004-5.75-1.853-7.86",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    fillRule: "evenodd",
    d: "M37.097 5.318C35.061 2.995 31.384 2 26.678 2H13.021c-.961 0-1.78.7-1.93 1.652L5.404 39.76a1.173 1.173 0 0 0 1.158 1.357h8.432L17.11 27.67l-.065.422a1.95 1.95 0 0 1 1.923-1.652h4.007c7.87 0 14.033-3.201 15.834-12.46a24 24 0 0 0 .14-.802c.535-3.422-.004-5.75-1.853-7.86z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#003087",
    fillRule: "evenodd",
    d: "M20.337 11.947c.225-.108.475-.168.739-.168H31.78c1.268 0 2.45.083 3.532.258q.464.075.902.171a13 13 0 0 1 1.254.345 9.7 9.7 0 0 1 1.48.625c.536-3.422-.003-5.75-1.852-7.86C35.061 2.995 31.384 2 26.678 2H13.021c-.961 0-1.78.7-1.93 1.652L5.404 39.76a1.173 1.173 0 0 0 1.158 1.357h8.432l4.393-27.894c.09-.572.457-1.04.95-1.277z",
    clipRule: "evenodd"
  })));
};
export default SvgPaypal;